import { Box, Button, Typography } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { FC, useRef } from "react";
import { useParams } from "react-router-dom";
import { usePostPartnerContactMutation } from "src/entities/partners/model/api/partners";
import { getPostPartnerContactDTO } from "src/entities/partners/model/helpers/helpers";
import {
  LoadingButton,
  ModalComponent,
  EConfirmModalType,
} from "src/shared/components";
import { modalText } from "src/shared/constants/form.constants";
import { useConfirmModal } from "src/shared/hooks";
import { IPartnerContactFormValues } from "../../model/types";
import { PartnerContactForm } from "./PartnerContactForm";

interface IAddContactModalProps {
  open: boolean;
  onClose: () => void;
}

export const AddContactModal: FC<IAddContactModalProps> = ({
  onClose,
  open,
}) => {
  const { partner_id } = useParams<{ partner_id: string }>();
  const formRef = useRef<HTMLFormElement>(null);
  const [postPartnerContact, { isLoading }] = usePostPartnerContactMutation();

  const handleSave = async (values: IPartnerContactFormValues) => {
    try {
      if (partner_id) {
        await postPartnerContact(
          getPostPartnerContactDTO({ ...values, partner_id: partner_id }),
        ).unwrap();
        onClose();
      }
    } catch (e) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
        handleClose: closeSnackbar,
      });
      console.log(e);
    }
  };

  const { modal, showModal } = useConfirmModal({
    onResolve: onClose,
    confirmModalType: EConfirmModalType.WARNING,
    confirmBtnProps: { isLoading: false, title: modalText.continue },
    children: <Typography>{modalText.unsavedChanges}</Typography>,
    title: modalText.confirmAction,
  });

  return (
    <>
      {modal}
      <ModalComponent
        width={450}
        disableBodyPadding
        onClose={showModal}
        open={open}
        title="Новый контакт"
        modalFooter={
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Button variant="outlined" onClick={showModal}>
              Отмена
            </Button>
            <LoadingButton
              isLoading={isLoading}
              variant="contained"
              onClick={() => {
                formRef.current?.submit();
              }}
            >
              Сохранить
            </LoadingButton>
          </Box>
        }
      >
        <PartnerContactForm ref={formRef} handleSave={handleSave} />
      </ModalComponent>
    </>
  );
};
